module.exports = __webpack_public_path__ + "static/media/survey-logo.7d0906b7.jpg";